import { createSlice } from "@reduxjs/toolkit";
import { serviceRefGrid, userTypeRoleDpdn } from "../../actions/security/serviceRefAction";
import { userActGrid } from "../../actions/security/UserAccountMgmtAction";

const initialState={
    loading:false,
    srvTableData:null,
    error:null,
    success:false,
    //dropdown
    loading1:false,
    typeRoleDpd:null,
    error1:null,
    success1:false
}

const serviceRefSlice = createSlice({
    name:"service-reference",
    initialState,
    extraReducers:(builder)=>{
        builder
        .addCase(serviceRefGrid.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success =false;
        })
        .addCase(serviceRefGrid.fulfilled, (state,{payload}) => {
            state.loading=false;
            state.srvTableData=payload;
            state.success=true;
            state.error=null;
        })
        .addCase(serviceRefGrid.rejected,(state, {paylaod})=>{
            state.loading=false;
            state.error=paylaod;
            state.success=false;
        })
        .addCase(userTypeRoleDpdn.pending, (state) => {
            state.loading1 = true;
            state.error1 = null;
            state.success1 =false;
        })
        .addCase(userTypeRoleDpdn.fulfilled, (state,{payload}) => {
            state.loading1=false;
            state.typeRoleDpd=payload;
            state.success1=true;
            state.error1=null;
        })
        .addCase(userTypeRoleDpdn.rejected,(state, {paylaod})=>{
            state.loading1=false;
            state.error1=paylaod;
            state.success1=false;
        })
    }
});

export default serviceRefSlice.reducer;